import { FC } from 'react';
import { Tabs } from '@aidkitorg/component-library';
import { useLocalizedStrings } from '../../../Localization';
import { RightSidebarProps } from './shared/types';
import { CaseNotesTab } from './tabs/CaseNotesTab';
import { ToolsTab } from './tabs/ToolsTab';
import { PhoneActionsTab } from './tabs/PhoneActionsTab';
import { SupportedLanguage } from '../../../Context';

export const RightSidebar: FC<RightSidebarProps> = ({
  caseInfo,
  applicantUid,
  verifiedContacts,
  applicantInfo,
  channel,
  onResolveParentCase
}) => {
  const L = useLocalizedStrings();

  const tabs = [
    {
      key: 'phone',
      name: L.support.phone,
      content: (
        <div className="py-3 px-2 h-screen">
          <PhoneActionsTab
            caseInfo={caseInfo}
            applicantInfo={applicantInfo}
          />
        </div>
      ),
    },
    {
      key: 'case-notes',
      name: L.support.case_notes,
      content: (
        <div className="py-3 px-2 h-screen">
          <CaseNotesTab
            contact={caseInfo.contact}
            applicant={applicantUid}
            channel={channel}
          />
        </div>
      ),
    },
    {
      key: 'tools',
      name: L.support.tools,
      content: (
        <div className="py-3 px-2 h-screen">
          <ToolsTab
            supportCaseId={caseInfo.uid}
            lang={(applicantInfo?.language as SupportedLanguage) || 'en'}
            verified={verifiedContacts || undefined}
            channel={channel}
            parentContact={caseInfo.contact}
            onResolveParentCase={onResolveParentCase}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="p-3 h-full flex flex-col overflow-hidden">
      <Tabs tabs={tabs} defaultTab="phone" justify="left" />
    </div>
  );
};
